import type { IntlShape } from 'react-intl';

export const formatCostConfigurationDate = (intl: IntlShape, date: Date): string =>
  intl.formatDate(date, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
